<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre Comercial</th>
                <th :class="StyleTh">Razón Social</th>
                <th :class="StyleTh">RFC</th>
                <th :class="StyleTh">Teléfono</th>
                <th :class="StyleTh">E-mail</th>
                <th :class="StyleTh">Tipo de Cliente</th>
                <th :class="StyleTh">Comisión %</th>
                 
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
					<td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
					<td><h6 :class="StylePr">{{lista.NombreComercial}}</h6></td>
                    <td><p :class="StyleTd">{{lista.RazonSocial}}</p></td>
                    <td><p :class="StyleTd">{{lista.RFC}}</p></td>
                    <td><p :class="StyleTd">{{lista.Telefono}}</p></td>
                    <td><p :class="StyleTd">{{lista.Email}}</p></td>
                    <td>
                        <p v-if="lista.TipoAgente==1" :class="StyleTd">Hotel con Comision</p>
                        <p v-if="lista.TipoAgente==2" :class="StyleTd">Hotel sin Comision</p>
                        <p v-if="lista.TipoAgente==3" :class="StyleTd">Independiente</p>
                    </td>
                    <td><p :class="StyleTd">{{lista.Comision}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion  :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="false" :pId="lista.IdAgente" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
							<template slot="btnaccion">
                                <CMoreButtonsL>
							        <template slot="bodyBtnsL">
                                        <template v-if="segurity.ViewCoordinators">
                                            <li @click="IrACoordinadores(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-user"></i> Ver Coordinadores
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.ViewPackages">
                                            <li @click="IrAPaquetes(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-box-full"></i> Ver Paquetes
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.ViewDestinations">
                                            <li @click="IrADestinos(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-map-marker"></i> Ver Destinos
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
			</template>
		</CList>
        <!-- <CModal :pConfigModal="ConfigModalCxA" :poBtnSave="oBtnSaveCxA">
            <template slot="Form">
                <Form :poBtnSave="oBtnSaveCxA"></Form>
            </template>
        </CModal> -->
	</div>
</template>
<script>

import Form from '@/views/catalogos/comisionesxAgente/FormAsignacion.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionAgente';
const EmitEjecuta2= 'seccionComisionesxAgente';

export default {
    name: 'ListaAgente',
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Hoteles & Empresas',
                IsModal: false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Configuración',
                GoRoute: 'agenteForm',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            // ConfigModalCxA:{
            //     ModalTitle: "Asignar Comisiones",
            //     ModalNameId: 'ModalFormCxA',
            //     EmitSeccion: EmitEjecuta2,
            // },
            oBtnSaveCxA: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,                
            ListaHeader: [],
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("agentes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('agentes/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        IrAPaquetes(item){
            this.$router.push({name:'paquete', params:{pObjEnviado:item}});
            // this.bus.$emit('NewModal_'+this.ConfigModalCxA.EmitSeccion,0,{});
            // this.bus.$emit('ListaComisiones');
        },
        IrACoordinadores(item){
            this.$router.push({name:'coordinadores', params:{pObjEnviado:item}});
        },
        IrADestinos(item){
            this.$router.push({name:'cpdestinos', params:{pObjEnviado:item,pOrigen:'HotelEmpresas'}});
        },
    },
    created()
    {
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
